
import { getProperty } from '../util/objHandle.js'
import {
  getData
} from 'requestModel'
import api from '../api/apiCertificate'

//平级拆分
//按照数据源维度区分 而不是页面级区分
//数据（一般不可定制） view（可定制）
//data => (store.js)control => (.vue)view
//存放state 单纯数据管理
export const state = () => ({
  certificate: {
    exist: false,
    info: {
      certificateId: 'sdfsdf',
      secLevel: 0,
      companyName: '',
      companyAddr: '',
      productName: '',
      productVer: '',
      institutionName: '',
      institutionAddr: '',
      timeStart: 0,
      timeEnd: 0,
    }
  }
})

export const actions = {
  async queryCertStatus ({
    commit
  }, params = {}) {
    let ret = await getData({
      api,
      dataset: ['queryCertificate'],
      params: {
        ...params
      }
    })

    if (getProperty(ret, 'certificate', null)) {
      commit('setCertificateData', ret.certificate)
    } else {
      ret = null
    }

    return ret
  }
}

export const mutations = {
  setCertificateData (state, certificate) {
    state.certificate = certificate
  }
}
